import { ENVIRONMENT } from "../env";

export function setGitMetaTag() {
    if (!ENVIRONMENT.GIT_COMMIT) {
        return;
    }
    const existing = document.head.querySelector<HTMLMetaElement>(
        'meta[name="app-version"]'
    );
    const meta = existing ?? document.createElement("meta");
    meta.name = "app-version";
    meta.content = ENVIRONMENT.GIT_COMMIT;
    if (!existing) {
        document.head.appendChild(meta);
    }
}
